import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { CeuUnit } from 'icreate/common/models/ceu-unit';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CeuUnitService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(fcuId: string) {
        return await lastValueFrom(
            this.http.get<CeuUnit[]>(`${this.domain}/api/ceuUnit`, {
                headers: this.headers,
                params: { fcuId },
            })
        );
    }

    async getListByVesselId(vesselId: string) {
        return await lastValueFrom(
            this.http.get<CeuUnit[]>(`${this.domain}/api/ceuUnit`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async createUnit(ceuUnit: CeuUnit[], fcuNum: number) {
        return await lastValueFrom(
            this.http.post<CeuUnit[]>(
                `${this.domain}/api/ceuUnit`,
                { ceuUnit, fcuNum },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async updateUnit(ceuUnit: CeuUnit[], fcuNum: number) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/ceuUnits`, { ceuUnit, fcuNum }, { headers: this.headers })
        );
    }

    async updatePorts(ceuUnits: CeuUnit[]) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/ceuUnits/ports`, ceuUnits, {
                headers: this.headers,
            })
        );
    }

    async deleteByCeu(ceuUnit: CeuUnit, fcuNum) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/ceuUnits`, { body: { ceuUnit, fcuNum } }));
    }
}
